import type { AssessmentQuestion, QuestionChoice } from '../types/assessmentQuestion';

// A choice with a resolved submit `value` (surveyChoiceUrn, or the order as a
// string fallback — phq/gad questions carry no urn).
export type ResolvedChoice = QuestionChoice & { value: string };
export type ActiveQuestion = Omit<AssessmentQuestion, 'choices'> & { choices: ResolvedChoice[] };

/**
 * Resolves every question's choices to a submittable `value` and normalizes
 * `questionType` to `'choice'` when the producer omitted it.
 *
 * Extracted out of `useAssessmentQuestions` so a single-question walk (that
 * hook) and a whole-page grouped render (`AssessmentContent`'s `singleScreen`
 * branch) resolve choices identically — one source of truth for "what value
 * does this choice submit", rather than two implementations that could drift.
 */
export function resolveQuestionChoices(questions: AssessmentQuestion[]): ActiveQuestion[] {
  return (questions ?? []).map((question) => ({
    ...question,
    questionType: question.questionType || 'choice',
    choices: question.choices.map((choice) => ({
      ...choice,
      value: choice.surveyChoiceUrn ? choice.surveyChoiceUrn : `${choice.order}`,
    })),
  }));
}
